import styled from 'styled-components'
import { Header, media } from '@popety-io/ui'

export const Layout = styled.div`
  height: 100vh;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.background.secondary};
  overflow: hidden;
`

export const StyledHeader = styled(Header)`
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(10px);
  background-color: rgba(255, 255, 255, 0.98);
  position: sticky;
  top: 0;
  box-sizing: border-box;
  height: ${({ theme }) => theme.layout.appHeaderHeight};
  min-height: ${({ theme }) => theme.layout.appHeaderHeight};
  padding: ${({ theme }) => `${theme.spacing.small} ${theme.spacing.large}`};
  z-index: ${({ theme }) => theme.zIndex.header};

  ${media.mobileOnly} {
    padding: ${({ theme }) => theme.spacing.small}
      ${({ theme }) => theme.spacing.medium};
  }
`

export const LogoContainer = styled.div`
  cursor: default;
  display: flex;
  align-items: center;

  img {
    height: 32px;
    width: auto;

    ${media.mobileOnly} {
      height: 24px;
    }
  }
`

export const HeaderActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.medium};

  ${media.mobileOnly} {
    gap: ${({ theme }) => theme.spacing.small};
  }
`

export const UserMenu = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
  color: ${({ theme }) => theme.colors.text.tertiary};
  font-family: ${({ theme }) => theme.typography.fontFamily.sans};
  line-height: ${({ theme }) => theme.typography.lineHeight.tight};

  ${media.mobileOnly} {
    display: none;
  }
`

export const UserName = styled.div`
  color: ${({ theme }) => theme.colors.text.tertiary};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  font-size: ${({ theme }) => theme.typography.fontSize.label};
`

export const UserMeta = styled.span`
  color: ${({ theme }) => theme.colors.text.tertiary};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  font-size: ${({ theme }) => theme.typography.fontSize.label};
`

export const Main = styled.main`
  flex: 1;
  overflow: hidden;
  min-height: 0;
  display: flex;
  flex-direction: column;
`
